import React from 'react';

/**
 * The two things an invitation link adds to the signup and login screens:
 * a banner saying why you are here, and the reason acceptance failed with a
 * way to try again.
 */

export function InvitationBanner({ children }) {
  return <div className="invitation-notice">{children}</div>;
}

export function InvitationError({ message, onRetry, disabled }) {
  if (!message) return null;
  return (
    <div className="error-message">
      {message}{' '}
      <button
        type="button"
        onClick={onRetry}
        disabled={disabled}
        className="invitation-retry"
      >
        Try again
      </button>
    </div>
  );
}
